import React from 'react';
import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';
import {ForecastQueryRenderer} from '../../../ForecastQueryRenderer';
import {TemplatesPage} from './TemplatesPage';
import {BaselineTemplatesPage, BaselineTemplatesPageQuery} from './baseline/BaselineTemplatesPage';
import {CreateBaselineTemplatePage, CreateBaselineTemplatePageQuery} from './baseline/create/CreateBaselineTemplatePage';

const TemplatesRoutes = (): JSX.Element => {
	const {path} = useRouteMatch();
	return (
		<Switch>
			<Route exact path={`${path}/baseline/new`}>
				<ForecastQueryRenderer
					key="query-render-CreateBaselineTemplatePage"
					query={CreateBaselineTemplatePageQuery}
					authorizeAccessRoute={'settings'}
					render={(relayProps: React.ComponentProps<typeof CreateBaselineTemplatePage>) => (
						<TemplatesPage showTabs={false}>
							<CreateBaselineTemplatePage {...relayProps} />
						</TemplatesPage>
					)}
				/>
			</Route>
			<Route exact path={`${path}/baseline`}>
				<ForecastQueryRenderer
					key="query-render-BaselineTemplatesPage"
					query={BaselineTemplatesPageQuery}
					authorizeAccessRoute={'settings'}
					render={(relayProps: React.ComponentProps<typeof BaselineTemplatesPage>) => (
						<TemplatesPage showTabs>
							<BaselineTemplatesPage {...relayProps} />
						</TemplatesPage>
					)}
				/>
			</Route>
			<Redirect to={`${path}/baseline`} />
		</Switch>
	);
};

export default TemplatesRoutes;
